import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { submitForm } from '../../redux/actions/submit';
import { uploadOneFile, uploadFileContact } from '../../redux/actions/upload';
import MetaSeo from '../MetaSeo';
import { toast, ToastContainer } from 'react-nextjs-toast';
import {
  validateEmailWithoutSpecial,
  validatePhoneNumber,
  trimText,
} from '../../lib/common';
const formRef = React.createRef();
const formRef_mb = React.createRef();

import useTrans from '../../hooks/useTrans';
import _ from 'lodash';

export default function Contact(props) {
  const dispatch = useDispatch();
  const fileref = useRef(null);
  const fileref_mb = useRef(null);
  const [fileupload, setFile] = useState(null);
  const trans = useTrans();
  const onDelaySubmit = _.debounce(() => OnSubmit(), 1000);

  const OnSubmit = async () => {
    await formRef.current.validateFields();
    let error_handle = false;
    let {
      name,
      email,
      mobile,
      title,
      note,
      purpose,
    } = formRef.current.getFieldsValue();
    let image = '';
    if (fileupload) {
      let newUploadFile = new FormData();
      newUploadFile.append('file', fileupload);

      image = await uploadFileContact(newUploadFile);

      if (!image || image === '') {
        error_handle = true;
        toast.notify(`File đính kèm không hợp lệ!`, {
          duration: 5,
          type: 'error',
          title: 'Có lỗi xảy ra',
        });
      }
    }
    let dataPush = {
      name,
      email,
      mobile,
      title,
      note,
      url: image,
      other_data: { purpose },
      type: 'contact',
    };
    if (error_handle === false) {
      const res = await submitForm(dataPush);
      if (res.code === 200) {
        message.success('Thành công');
        // toast.notify('Đã gửi thành công', {
        //   duration: 120,
        //   type: 'success',
        //   title: 'Thành công',
        // });
        formRef.current.resetFields();
        setFile(null);
      } else {
        // message.success('Thành công');
        toast.notify(`${res.message}`, {
          duration: 5,
          type: 'error',
          title: 'Có lỗi xảy ra',
        });
      }
    }

    setTimeout(() => {
      toast.remove();
    }, 3000);
  };

  const OnSubmit_mb = async () => {
    await formRef_mb.current.validateFields();
    let error_handle = false;
    let {
      name,
      email,
      mobile,
      title,
      note,
      purpose,
    } = formRef_mb.current.getFieldsValue();
    let image = '';
    if (fileupload) {
      let newUploadFile = new FormData();
      newUploadFile.append('file', fileupload);

      image = await uploadFileContact(newUploadFile);

      if (!image || image === '') {
        error_handle = true;
        toast.notify(`File đính kèm không hợp lệ!`, {
          duration: 5,
          type: 'error',
          title: 'Có lỗi xảy ra',
        });
      }
    }
    let dataPush = {
      name,
      email,
      mobile,
      title,
      note,
      url: image,
      other_data: { purpose },
      type: 'contact',
    };
    if (error_handle === false) {
      const res = await submitForm(dataPush);
      if (res.code === 200) {
        message.success('Thành công');
        // toast.notify('Đã gửi thành công', {
        //   duration: 120,
        //   type: 'success',
        //   title: 'Thành công',
        // });
        formRef_mb.current.resetFields();
        setFile(null);
      } else {
        // message.success('Thành công');
        toast.notify(`${res.message}`, {
          duration: 5,
          type: 'error',
          title: 'Có lỗi xảy ra',
        });
      }
    }

    setTimeout(() => {
      toast.remove();
    }, 3000);
  };
  const regexPhoneNumber = /^((\+)84|0)[1-9](\d{2}){4}$/;

  const trimInput = (key, e) => {
    let { value } = e.target;
    formRef.current.setFieldsValue({ [key]: value.trim() });
  };
  const dataSeo = {
    title: 'Contact | TCOM Global',
    description:
      'Just shoot over your details if you need some advice, a price quote, or to set up some sort of business partnership. You can contact us whenever you like by sending an email. We are here to hear you out and give you our full backing',
  };
  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className="main-content">
        <div className="r-contact-form">
          <div className="container container-contact">
            <ToastContainer position={'top'} />
            <div className="row qjhrqhwrhqwr">
              <div className="col-12 col-md-6">
                <div className="info">
                  <h1>{trans.contact.title}</h1>
                  <div
                    className="ehjwbeb-dt"
                    dangerouslySetInnerHTML={{
                      __html: trans.contact.description,
                    }}
                  ></div>
                  <div
                    className="ehjwbeb-mb"
                    dangerouslySetInnerHTML={{
                      __html: trans.contact.description,
                    }}
                  ></div>
                  <div className="col-12 col-md-6 dnhuqjsnfnf diqwfnsasdnasdnad diqwfnsasdnasdnad-mb">
                    <div className="form">
                      <Form ref={formRef_mb}>
                        <div className="form-group">
                          <label className="form-group-title">
                            {trans.contact.name}
                          </label>
                          <Form.Item
                            name="name"
                            rules={[
                              { required: true, message: trans.error.name },
                            ]}
                          >
                            <input
                              type="text"
                              onBlur={e => trimInput('name', e)}
                              c
                              className="form-control"
                              placeholder={trans.contact.form_name}
                            />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <label className="form-group-title">Email</label>
                          <Form.Item
                            name="email"
                            rules={[
                              {
                                validator: (_, value) => {
                                  if (!value || value.trim() === '') {
                                    return Promise.reject(trans.error.mail);
                                  }
                                  if (!validateEmailWithoutSpecial(value)) {
                                    return Promise.reject(
                                      trans.error.mail_format,
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <input
                              className="form-control"
                              onBlur={e => trimInput('email', e)}
                              placeholder="Work email"
                            />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <label className="form-group-title">
                            {trans.contact.phone}
                          </label>
                          <Form.Item
                            name="mobile"
                            rules={[
                              // { required: true, message: 'Vui lòng điền số điện thoại!' },
                              {
                                validator: (_, value) => {
                                  if (!value || value.trim() === '') {
                                    return Promise.reject(trans.error.phone);
                                  }
                                  if (value && isNaN(value)) {
                                    return Promise.reject(
                                      trans.error.phone_format,
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <input
                              className="form-control"
                              placeholder={trans.contact.form_phone}
                            />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <label className="form-group-title">
                            {trans.contact.tieu_de}
                          </label>
                          <Form.Item
                            name="title"
                            rules={[
                              {
                                required: true,
                                message: trans.error.subject,
                              },
                            ]}
                          >
                            <input
                              type="text"
                              onBlur={e => trimInput('title', e)}
                              className="form-control"
                              placeholder={trans.contact.form_subject}
                            />
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <label className="form-group-title">
                            {trans.contact.purpose}
                          </label>
                          <Form.Item
                            name="purpose"
                            rules={[
                              {
                                required: true,
                                message: trans.error.need,
                              },
                            ]}
                          >
                            <select className="form-control" name id>
                              <option value="">
                                {trans.contact.form_purpose}
                              </option>
                              <option value="Báo giá">
                                {trans.contact.form_quotation}
                              </option>
                              <option value="Yêu cầu tư vấn">
                                {trans.contact.form_request}
                              </option>
                              <option value="Hợp tác">
                                {trans.contact.form_cooperation}
                              </option>
                              <option value="Tuyển dụng">
                                {trans.contact.form_recruitment}
                              </option>
                              <option value="Khác">
                                {trans.contact.form_orther}
                              </option>
                            </select>
                          </Form.Item>
                        </div>
                        <div className="form-group">
                          <label className="form-group-title">
                            {trans.contact.content}
                          </label>
                          <Form.Item
                            name="note"
                            rules={[
                              {
                                required: true,
                                message: trans.error.message,
                              },
                            ]}
                          >
                            <textarea
                              onBlur={e => trimInput('note', e)}
                              className="form-control"
                              placeholder={trans.contact.form_message}
                            />
                          </Form.Item>
                        </div>

                        <div className="custom-file">
                          <Form.Item
                            name="fileItem"
                            rules={[
                              {
                                validator: (_, value) => {
                                  if (!fileupload) {
                                    return Promise.reject(trans.error.file);
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <input
                              onChange={e => {
                                setFile(e.target.files[0]);
                                formRef.current.validateFields();
                              }}
                              style={{ opacity: 0 }}
                              ref={fileref_mb}
                              type="file"
                              className="custom-file-input form-control"
                              id="customFile"
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="customFile"
                              data-content={
                                fileupload?.name
                                  ? fileupload?.name
                                  : trans.contact.form_file
                              }
                            >
                              <svg
                                width={20}
                                height={21}
                                viewBox="0 0 20 21"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.383 10.1262C16.5004 10.2447 16.5662 10.4047 16.5662 10.5715C16.5662 10.7383 16.5004 10.8983 16.383 11.0168L9.96897 17.4152C9.14846 18.2357 8.0356 18.6967 6.87522 18.6967C5.71484 18.6967 4.60199 18.2357 3.78147 17.4152C2.96096 16.5947 2.5 15.4819 2.5 14.3215C2.5 13.1611 2.96096 12.0482 3.78147 11.2277L11.5393 3.36836C11.8263 3.06571 12.171 2.82359 12.5531 2.65626C12.9352 2.48894 13.3469 2.3998 13.764 2.39409C14.181 2.38839 14.595 2.46623 14.9815 2.62304C15.3681 2.77986 15.7193 3.01246 16.0145 3.30714C16.3097 3.60182 16.5429 3.95261 16.7004 4.33885C16.8579 4.72508 16.9365 5.13894 16.9315 5.55602C16.9265 5.9731 16.8381 6.38497 16.6715 6.76734C16.5048 7.14971 16.2633 7.49485 15.9612 7.78242L8.20335 15.6418C8.02994 15.8179 7.82317 15.9576 7.59513 16.0529C7.36709 16.1481 7.12235 16.1969 6.87522 16.1965C6.50371 16.1974 6.14031 16.0879 5.83112 15.882C5.52193 15.676 5.28089 15.3828 5.1386 15.0396C4.9963 14.6965 4.95916 14.3187 5.03189 13.9544C5.10462 13.5901 5.28394 13.2556 5.5471 12.9934L12.0549 6.38398C12.1112 6.32082 12.1798 6.26975 12.2564 6.23386C12.3331 6.19798 12.4162 6.17804 12.5008 6.17524C12.5853 6.17244 12.6696 6.18685 12.7485 6.21759C12.8273 6.24833 12.8991 6.29476 12.9594 6.35406C13.0198 6.41337 13.0675 6.48432 13.0996 6.5626C13.1318 6.64089 13.1477 6.72489 13.1464 6.8095C13.1451 6.89412 13.1266 6.97758 13.0921 7.05485C13.0575 7.13211 13.0077 7.20156 12.9455 7.25898L6.43772 13.8762C6.37848 13.9342 6.33139 14.0035 6.2992 14.08C6.26701 14.1564 6.25036 14.2385 6.25022 14.3215C6.24928 14.4878 6.31383 14.6477 6.42991 14.7668C6.54988 14.8815 6.70926 14.9458 6.87522 14.9465C7.0415 14.9474 7.20147 14.8829 7.32053 14.7668L15.0705 6.89961C15.2466 6.7262 15.3864 6.51943 15.4816 6.29139C15.5768 6.06335 15.6257 5.81861 15.6252 5.57148C15.6261 5.19997 15.5167 4.83657 15.3107 4.52738C15.1047 4.21819 14.8116 3.97715 14.4684 3.83486C14.1252 3.69256 13.7475 3.65542 13.3832 3.72815C13.0188 3.80088 12.6843 3.9802 12.4221 4.24336L4.6721 12.1105C4.36945 12.3976 4.12733 12.7423 3.96001 13.1244C3.79268 13.5064 3.70354 13.9182 3.69783 14.3352C3.69213 14.7523 3.76997 15.1663 3.92678 15.5528C4.0836 15.9393 4.3162 16.2905 4.61088 16.5857C4.90556 16.8809 5.25636 17.1142 5.64259 17.2716C6.02882 17.4291 6.44268 17.5077 6.85976 17.5028C7.27684 17.4978 7.68871 17.4094 8.07108 17.2427C8.45345 17.0761 8.79859 16.8346 9.08616 16.5324L15.4924 10.1262C15.6109 10.0088 15.7709 9.94297 15.9377 9.94297C16.1045 9.94297 16.2645 10.0088 16.383 10.1262Z"
                                  fill="#0063AA"
                                />
                              </svg>
                            </label>
                          </Form.Item>
                          {/* </Form.Item> */}
                        </div>
                        <div className="text-right">
                          <button onClick={OnSubmit_mb} type="submit">
                            {trans.contact.submit}
                          </button>
                        </div>
                      </Form>
                    </div>
                  </div>
                  <div className="block-contact">
                    <h3>{trans.contact.contacttitle}</h3>
                    <ul>
                      <li>
                        <img src="/assets/images/offshore/call.svg" alt="" />
                        <a href="tel:+84 24 3910 2030">+84 24 3910 2030</a>
                      </li>
                      {/* update phone, email */}
                      <li className="phone-vn">
                        <img src="/assets/images/offshore/mail.svg" alt="" />
                        <a href="mailto:info@tcomglobal.com">info@tcomglobal.com</a>
                      </li>

                      {/* end update phone, email */}
                    </ul>
                  </div>

                  <div className="block-contact">
                    <h3>KEEP IN TOUCH</h3>
                    <ul id="iqeihfhsf">
                      <li>
                        <a href="">
                          {' '}
                          <img src="/assets/images/offshore/f.svg" alt="" />
                        </a>
                      </li>
                      {/* update phone, email */}
                      <li className="phone-vn">
                        <a href="">
                          <img src="/assets/images/offshore/in.svg" alt="" />
                        </a>
                      </li>

                      <li className="phone-vn">
                        <a href="">
                          <img src="/assets/images/offshore/y.svg" alt="" />
                        </a>
                      </li>

                      {/* end update phone, email */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 dnhuqjsnfnf">
                <div className="form">
                  <Form ref={formRef}>
                    <div className="form-group">
                      <label className="form-group-title">
                        {trans.contact.name}
                      </label>
                      <Form.Item
                        name="name"
                        rules={[{ required: true, message: trans.error.name }]}
                      >
                        <input
                          type="text"
                          onBlur={e => trimInput('name', e)}
                          c
                          className="form-control"
                          placeholder={trans.contact.form_name}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group">
                      <label className="form-group-title">Email</label>
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === '') {
                                return Promise.reject(trans.error.mail);
                              }
                              if (!validateEmailWithoutSpecial(value)) {
                                return Promise.reject(trans.error.mail_format);
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          className="form-control"
                          onBlur={e => trimInput('email', e)}
                          placeholder="Work email"
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group">
                      <label className="form-group-title">
                        {trans.contact.phone}
                      </label>
                      <Form.Item
                        name="mobile"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === '') {
                                return Promise.reject(trans.error.phone);
                              }
                              if (value && isNaN(value)) {
                                return Promise.reject(trans.error.phone_format);
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          className="form-control"
                          placeholder={trans.contact.form_phone}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group">
                      <label className="form-group-title">
                        {trans.contact.tieu_de}
                      </label>
                      <Form.Item
                        name="title"
                        rules={[
                          { required: true, message: trans.error.subject },
                        ]}
                      >
                        <input
                          type="text"
                          onBlur={e => trimInput('title', e)}
                          className="form-control"
                          placeholder={trans.contact.form_subject}
                        />
                      </Form.Item>
                    </div>
                    <div className="form-group">
                      <label className="form-group-title">
                        {trans.contact.purpose}
                      </label>
                      <Form.Item
                        name="purpose"
                        rules={[
                          {
                            required: true,
                            message: trans.error.need,
                          },
                        ]}
                      >
                        <select className="form-control" name id>
                          <option value=""> {trans.contact.option_a}</option>
                          <option value="Báo giá">
                            {trans.contact.option_b}
                          </option>
                          <option value="Yêu cầu tư vấn">
                            {trans.contact.option_c}
                          </option>
                          <option value="Hợp tác">
                            {trans.contact.option_d}
                          </option>
                          <option value="Tuyển dụng">
                            {trans.contact.option_e}
                          </option>
                          <option value="Khác">{trans.contact.option_f}</option>
                        </select>
                      </Form.Item>
                    </div>
                    <div className="form-group">
                      <label className="form-group-title">
                        {trans.contact.content}
                      </label>
                      <Form.Item
                        name="note"
                        rules={[
                          {
                            required: true,
                            message: trans.error.message,
                          },
                        ]}
                      >
                        <textarea
                          onBlur={e => trimInput('note', e)}
                          className="form-control"
                          placeholder={trans.contact.form_message}
                        />
                      </Form.Item>
                    </div>

                    <div className="custom-file">
                      <Form.Item
                        name="fileItem"
                        // rules={[{ required: true, message: 'Vui lòng chọn file đính kèm!' }]}
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!fileupload) {
                                return Promise.reject(trans.error.file);
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          onChange={e => {
                            setFile(e.target.files[0]);
                            formRef.current.validateFields();
                            console.log(fileupload);
                          }}
                          style={{ opacity: 0 }}
                          ref={fileref}
                          type="file"
                          className="custom-file-input form-control"
                          id="customFile"
                        />
                        <label
                          className="custom-file-label"
                          htmlFor="customFile"
                          data-content={
                            fileupload?.name
                              ? fileupload?.name
                              : trans.contact.form_file
                          }
                        >
                          <svg
                            width={20}
                            height={21}
                            viewBox="0 0 20 21"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.383 10.1262C16.5004 10.2447 16.5662 10.4047 16.5662 10.5715C16.5662 10.7383 16.5004 10.8983 16.383 11.0168L9.96897 17.4152C9.14846 18.2357 8.0356 18.6967 6.87522 18.6967C5.71484 18.6967 4.60199 18.2357 3.78147 17.4152C2.96096 16.5947 2.5 15.4819 2.5 14.3215C2.5 13.1611 2.96096 12.0482 3.78147 11.2277L11.5393 3.36836C11.8263 3.06571 12.171 2.82359 12.5531 2.65626C12.9352 2.48894 13.3469 2.3998 13.764 2.39409C14.181 2.38839 14.595 2.46623 14.9815 2.62304C15.3681 2.77986 15.7193 3.01246 16.0145 3.30714C16.3097 3.60182 16.5429 3.95261 16.7004 4.33885C16.8579 4.72508 16.9365 5.13894 16.9315 5.55602C16.9265 5.9731 16.8381 6.38497 16.6715 6.76734C16.5048 7.14971 16.2633 7.49485 15.9612 7.78242L8.20335 15.6418C8.02994 15.8179 7.82317 15.9576 7.59513 16.0529C7.36709 16.1481 7.12235 16.1969 6.87522 16.1965C6.50371 16.1974 6.14031 16.0879 5.83112 15.882C5.52193 15.676 5.28089 15.3828 5.1386 15.0396C4.9963 14.6965 4.95916 14.3187 5.03189 13.9544C5.10462 13.5901 5.28394 13.2556 5.5471 12.9934L12.0549 6.38398C12.1112 6.32082 12.1798 6.26975 12.2564 6.23386C12.3331 6.19798 12.4162 6.17804 12.5008 6.17524C12.5853 6.17244 12.6696 6.18685 12.7485 6.21759C12.8273 6.24833 12.8991 6.29476 12.9594 6.35406C13.0198 6.41337 13.0675 6.48432 13.0996 6.5626C13.1318 6.64089 13.1477 6.72489 13.1464 6.8095C13.1451 6.89412 13.1266 6.97758 13.0921 7.05485C13.0575 7.13211 13.0077 7.20156 12.9455 7.25898L6.43772 13.8762C6.37848 13.9342 6.33139 14.0035 6.2992 14.08C6.26701 14.1564 6.25036 14.2385 6.25022 14.3215C6.24928 14.4878 6.31383 14.6477 6.42991 14.7668C6.54988 14.8815 6.70926 14.9458 6.87522 14.9465C7.0415 14.9474 7.20147 14.8829 7.32053 14.7668L15.0705 6.89961C15.2466 6.7262 15.3864 6.51943 15.4816 6.29139C15.5768 6.06335 15.6257 5.81861 15.6252 5.57148C15.6261 5.19997 15.5167 4.83657 15.3107 4.52738C15.1047 4.21819 14.8116 3.97715 14.4684 3.83486C14.1252 3.69256 13.7475 3.65542 13.3832 3.72815C13.0188 3.80088 12.6843 3.9802 12.4221 4.24336L4.6721 12.1105C4.36945 12.3976 4.12733 12.7423 3.96001 13.1244C3.79268 13.5064 3.70354 13.9182 3.69783 14.3352C3.69213 14.7523 3.76997 15.1663 3.92678 15.5528C4.0836 15.9393 4.3162 16.2905 4.61088 16.5857C4.90556 16.8809 5.25636 17.1142 5.64259 17.2716C6.02882 17.4291 6.44268 17.5077 6.85976 17.5028C7.27684 17.4978 7.68871 17.4094 8.07108 17.2427C8.45345 17.0761 8.79859 16.8346 9.08616 16.5324L15.4924 10.1262C15.6109 10.0088 15.7709 9.94297 15.9377 9.94297C16.1045 9.94297 16.2645 10.0088 16.383 10.1262Z"
                              fill="#0063AA"
                            />
                          </svg>
                        </label>
                      </Form.Item>
                      {/* </Form.Item> */}
                    </div>
                    <div className="text-right">
                      <button onClick={onDelaySubmit} type="submit">
                        {trans.contact.submit}
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* member */}
        <div className="member-system">
          <div className="member-system-container">
            <div className="container">
              <div className="block-contact kdqhfsiqihjfsf">
                <h3>OFFICE</h3>
                <div className="member-system-items">
                  <div className="member-system-item">
                    <h1> {trans.contact.title_l_a}</h1>
                    <p>{trans.contact.title_l_d_a}</p>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3724.756848314058!2d105.81730457605195!3d21.002381780640295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135ac9094605afd%3A0x13693c25328b67ad!2zRmFmaW0gTmfDoyBUxrAgU-G7nw!5e0!3m2!1svi!2s!4v1685001067184!5m2!1svi!2s"
                      width={350}
                      height={221.54}
                    ></iframe>
                  </div>

                  <div className="member-system-item">
                    <h1> {trans.contact.title_l_b}</h1>
                    <p>{trans.contact.title_l_d_b}</p>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.2020181485254!2d106.67579567587983!3d10.795833989354128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317528d677dab3d7%3A0xc3583be4c9df2fde!2zMTAyIE5ndXnhu4VuIMSQw6xuaCBDaMOtbmgsIFBoxrDhu51uZyAxNSwgUGjDuiBOaHXhuq1uLCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmgsIFZp4buHdCBOYW0!5e0!3m2!1svi!2s!4v1685001536803!5m2!1svi!2s"
                      width={350}
                      height={221.54}
                    ></iframe>
                  </div>

                  <div className="member-system-item">
                    <h1> {trans.contact.title_l_c}</h1>
                    <p>{trans.contact.title_l_d_c}</p>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d440.30956543225653!2d139.41186955720207!3d35.69544117927426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e17bef0aee83%3A0xd79cd120123778f!2z77yI5qCq77yJ44GR44KE44GN5Ye654mI!5e0!3m2!1svi!2s!4v1685001675801!5m2!1svi!2s"
                      width={350}
                      height={221.54}
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{' '}
        {/* end member */}
      </div>
    </>
  );
}
